import React from 'react';
import RoiForm from './RoiForm';

const RoiCalculator = () => {
	return (
		<React.Fragment>
			<RoiForm />
		</React.Fragment>
	);
};

export default RoiCalculator;
